import React from "react";
import PlayerStatisticPanel from "./PlayerStatisticPanel";

const PremiumBlurPanel: React.FC = () => (
  <PlayerStatisticPanel
    titleKey="evaluation"
    players={[]}
    formatAsDecimal
    shouldBlur
    showBanner
  />
);

export default PremiumBlurPanel;

